module.exports = __webpack_public_path__ + "static/media/act_services_matrix_center.3c48613a.png";